import React, { useState } from 'react';
import classnames from 'classnames';
import { func } from 'prop-types';
import { noop } from 'lodash';
import { I18n } from '@fiverr-private/i18n-react';
import { Icon, Button } from '@fiverr-private/fit';
import { r_times } from '@fiverr-private/icons';
import FavoriteIcon from './FavoriteIcon';
import { FADE_TIME } from './constants';
import './style.scss';

const FavoritesEducation = ({ onClose = noop }) => {
    const [hide, setHide] = useState(false);

    const close = () => {
        setHide(true);
        setTimeout(onClose, FADE_TIME);
    };

    return (
        <>
            <div className={classnames('favorites-education', { hide })}>
                <span className="favorites-education-arrow" />
                <Icon size={22} onClick={close} className="favorites-education-close-icon">
                    {r_times}
                </Icon>

                <div className="content">
                    <FavoriteIcon />
                    <div>
                        <h6>
                            <I18n k="logo_maker_perseus.buyer.education.title" />
                        </h6>
                        <I18n k="logo_maker_perseus.buyer.education.message" />
                    </div>
                </div>
                <div className="actions">
                    <Button color="blue" onClick={close}>
                        <I18n k="logo_maker_perseus.buyer.education.got_it" />
                    </Button>
                </div>
            </div>
            <div className={classnames('favorites-education-lock', { hide })} />
        </>
    );
};

FavoritesEducation.propTypes = {
    onClose: func,
};

export * from './helpers';
export default FavoritesEducation;
